// extracted by mini-css-extract-plugin
export var aboveInput = "_nv-0";
export var actionButton = "_nv-5";
export var actionButtonContainer = "_nv-1";
export var actionIcon = "_nv-6";
export var aiInfoContainer = "_nv-2";
export var attachmentWrapper = "_nv-7";
export var bold = "_nv-3";
export var checkIcon = "_nv-8";
export var clickingRecipientBar = "_nv-11";
export var commentThreadSwitch = "_nv-a";
export var draftImage = "_nv-b";
export var draftImageContainer = "_nv-c";
export var draftImages = "_nv-e";
export var editButton = "_nv-g";
export var editor = "_nv-f";
export var editorContainer = "_nv-y";
export var editorErrorTooltipWrapper = "_nv-9";
export var headerDivider = "_nv-h";
export var icon = "_nv-i";
export var info = "_nv-j";
export var internal = "_nv-n";
export var internalDivider = "_nv-k";
export var internalMessage = "_nv-l";
export var messageInputCard = "_nv-m";
export var messageInputForm = "_nv-o";
export var messageInputFormInternal = "_nv-p";
export var options = "_nv-q";
export var publicMessageCustomer = "_nv-s";
export var publicMessageMerchant = "_nv-r";
export var removeImageButton = "_nv-d";
export var replyButtons = "_nv-t";
export var showSignatureButton = "_nv-u";
export var spinner = "_nv-v";
export var verticalButtonDivider = "_nv-4";
export var visibilitySelector = "_nv-w";
export var warning = "_nv-x";
export var wrappingText = "_nv-z";
export var writingInternalNoteTopBorder = "_nv-10";